// react and mui stuff
import { Dispatch, SetStateAction } from "react"

import Button from "@mui/joy/Button"

// data and stuff
import { CliUser } from "../../types/users"
import { ErrMsg } from "../../utils/backend"
import { toast } from "../../components/toast"
import { setData } from "../../utils/setdata"

export type ReportProps<report> = {
  report: report | undefined
  setReport: Dispatch<SetStateAction<report | undefined>>
  setToast: Dispatch<SetStateAction<toast | undefined>>
  user: CliUser | null | undefined
  setUser: Dispatch<SetStateAction<CliUser | null | undefined>>
}

type fetchProps<report> = {
  setLoading: Dispatch<SetStateAction<boolean>>
  loading: boolean
  apiFunction: () => Promise<report | ErrMsg>
  setToast: Dispatch<SetStateAction<toast | undefined>>
  user: CliUser | null | undefined
  setUser: Dispatch<SetStateAction<CliUser | null | undefined>>
  setReport: Function
  callback?: (report: report) => report
}

export function FetchButton<report>(props: fetchProps<report>) {
  return (
    <Button onClick={() => {
      props.setLoading(true)
      props.apiFunction().then(info => {
        props.setLoading(false);
        if (!setData(info, props.setToast, props.user, props.setUser)) return;

        if (props.callback) info = props.callback(info)
        props.setReport(info)
      })
  
    }} loading={props.loading}>Fetch Report</Button>
  )
}